// Don't destructure Fancybox, as it's an external in this webpack config
import Fancybox from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

Fancybox.bind('[data-fancybox]', {
	Thumbs: {
		type: 'classic',
	},
});

const photoGalleries = [...document.querySelectorAll('.photo-gallery')];

photoGalleries.forEach((gallery) => {
	const swiperGallery = gallery.querySelector('.swiper-photo-gallery');
	if (!swiperGallery) return;

	const navigation = gallery.querySelector('.swiper-navigation');

	const slidesPerView = Number(swiperGallery.dataset.swiperColumns) || 4;

	new Swiper(swiperGallery, {
		modules: [Navigation, Pagination, A11y],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 2.05,
		spaceBetween: 16,
		keyboard: { enabled: true },
		navigation: {
			nextEl: gallery.querySelector('.swiper-button-next'),
			prevEl: gallery.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(gallery.querySelector('.swiper-pagination')),
		breakpoints: {
			760: { slidesPerView, spaceBetween: 32 },
			1024: { slidesPerView },
		},
		on: {
			lock: () => {
				navigation.style.display = 'none';
			},
			unlock: () => {
				navigation.style.display = 'flex';
			},
		},
	});
});
